<template>
  <div class="row">
    <div class="col-auto">
      <div
        class="img-fluid img-thumbnail img-squared mr-4 shadow-sm"
        style="height: 12em; width: 12em"
        :style="
          'background-image: url(' +
          url +
          'public/images/' +
          item.kind +
          's/' +
          (item.image ? item.image : 'blank.png') +
          ')'
        "
      ></div>
    </div>
    <div class="col">
      <h3>
        <router-link
          :to="{
            name: item.kind,
            params: { id: item._id, title: item.name.replace(/\s/g, '-') },
          }"
          >{{ item.name }}</router-link
        ><span v-if="item.discount" class="badge badge-success ml-3"
          >{{ item.discount }}% off</span
        >
      </h3>
      <h4 class="pt-2 font-weight-bold text-danger">
        SC$ {{( priceSC * (1 - item.discount / 100)).toFixed(2) }}
      </h4>
      <span
        class="badge badge-dark mr-1 p-2"
        v-for="option in item.options"
        :key="option._id"
        >{{ option.form.name }}: {{ option.value }}</span
      >
    </div>
    <div class="col-auto pt-2">
      <input
        class="form-control"
        type="number"
        name=""
        id=""
        v-model="amount"
        v-on:input="addAmount"
        style="width: 4em"
        min="0"
        max="999"
      />
    </div>
    <div class="col-auto pt-3 pr-3 text-center d-flex flex-column">
      <span class="mb-auto"
        >Subtotal: SC$
        {{
          (priceSC * (1 - item.discount / 100) * amount).toFixed(2)
        }}</span
      >
      <div>
        <span class="material-icons btn btn-danger ml-2" @click="removeItem()">
          delete_outline
        </span>
      </div>
    </div>
    <div class="col-12">
      <hr />
    </div>
  </div>
</template>

<script>
import Configs from "../configs/configs";
import { mapState } from "vuex";
import { LC } from "../tools/exchange";

export default {
  name: "ItemCart",
  props: {
    item: Object,
  },
  data() {
    return {
      url: Configs.API.BASE,
      amount: 1,
      localCurrency: null,
    };
  },
  created: function () {
    this.amount = this.item.amountInCart;
    LC.new().then((localCurrency) => (this.localCurrency = localCurrency));
  },
  methods: {
    addAmount() {
      this.$emit("add", { id: this.item._id, amount: Number(this.amount) });
    },
    removeItem() {
      this.$emit("remove", this.item._id);
    },
  },
  computed: {
    ...mapState(["changes"]),
    priceSC(){
      if(!this.localCurrency) return 0;
      return this.localCurrency.localToSC({price: this.item.price, currency: this.item.currency})
    }
  },
};
</script>

<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  opacity: 1;
}
</style>